<div class="overview">
  <app-group-information
    [groupData]="groupData"
    (migrateGroup)="migrateGroup()"
    (changePlan)="changePlan()"
  ></app-group-information>

  <div class="search">
    <app-search-field
      placeholder="Search Website"
      (searchText)="onSearch($event)"
    ></app-search-field>
  </div>

  <div class="websites">
    <div class="header row">
      <h2>Websites in this Group</h2>

      <div class="buttons row space">
        <button matButton="filled" class="app-btn-small" (click)="addWebsite()">
          <fa-icon matPrefix [icon]="['fas', 'plus']" size="sm"></fa-icon>
          Add Website
        </button>

        <!-- <button matButton="outlined" class="app-btn-small">
          <fa-icon matPrefix [icon]="['fas', 'arrows-rotate']" size="sm"></fa-icon>
          Sync Databases Size
        </button> -->
      </div>
    </div>

    <mat-card appearance="filled" class="table-container">
      @if (websites$ | async; as websites) {
        <app-table
          [columns]="websiteColumns"
          [dataSource]="websites"
          [totalCount]="totalWebsites()"
          (pageChange)="handlePageEvent($event)"
        >
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <app-status-label [status]="element.status"></app-status-label>
            </td>
          </ng-container>

          <ng-container matColumnDef="buttons">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons row">
                <div
                  matRipple
                  class="icon-button"
                  matTooltip="Install SSL Certificate"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                >
                  <fa-icon [icon]="['fas', 'lock']" size="lg"></fa-icon>
                </div>
                <div
                  matRipple
                  class="icon-button"
                  matTooltip="Edit DNS Zone"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  [routerLink]="['/overview', element.id]"
                  [queryParams]="{ tab: 'dns' }"
                >
                  <img class="custom-icon" src="assets/icons/dns-icon.svg" alt="DNS" />
                </div>

                <div
                  matRipple
                  class="icon-button"
                  matTooltip="Manage website, install ssl, manage php, cdn and others."
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  [routerLink]="['/overview', element.id]"
                >
                  <fa-icon [icon]="['fas', 'arrow-right']" size="lg"></fa-icon>
                </div>
              </div>
            </td>
          </ng-container>
        </app-table>
      }
    </mat-card>
  </div>

  @if (groupData.diskUsage) {
    <div class="usage">
      <div class="header row">
        <h2>Group Usage</h2>

        <div class="buttons row">
          <button
            matButton="outlined"
            class="app-btn-small"
            [routerLink]="['/usage/group', groupData.websiteGroup.id]"
          >
            More details
            <fa-icon matPrefix [icon]="['fas', 'arrow-right-long']" size="sm"></fa-icon>
          </button>
        </div>
      </div>

      <app-group-usage
        [groupId]="groupData.websiteGroup.id"
        [userId]="groupData.systemUser.id"
        [diskUsage]="groupData.diskUsage"
        [cpuUsage]="groupData.cpuUsage"
        [bandwidthUsage]="groupData.bandwidthUsage"
        [plan]="groupData.hostingPlan"
      ></app-group-usage>
    </div>
  }
</div>
